import { createAction } from '@reduxjs/toolkit'

import { IComponentData } from 'pages/component-management/types'

export const initComponentManagement = createAction<IComponentData | undefined>(
  '@COMPONENT_MANAGEMENT/init'
)
